export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const ACTIVATE_USER = "activate_user"
export const ACTIVATE_USER_SUCCESS = "activate_user_success"
export const ACTIVATE_USER_FAIL = "activate_user_fail"


